import { Radio } from 'lucide-react';
import { useTranslation } from '@/i18n/LanguageContext';

interface Props {
  /** Email addresses of users currently present on the workspace channel (incl. self). */
  collaborators: string[];
}

/**
 * Small pill in the TopBar showing that Co-op realtime sync is active and
 * how many people (including you) are connected to the channel. Emails are
 * listed in the tooltip; the pill always displays the participant count.
 */
export function CoopPresenceBadge({ collaborators }: Props) {
  const { t } = useTranslation();
  const count = collaborators.length || 1;
  return (
    <span
      className="flex items-center gap-1 rounded-full bg-emerald-500/15 px-2 py-0.5 text-[10px] font-semibold text-emerald-700 dark:text-emerald-400"
      title={collaborators.length ? collaborators.join('\n') : t('coopActive')}
      data-testid="coop-presence-badge"
    >
      <Radio className="w-3 h-3 animate-pulse" />
      {t('coopCollaborators')} · {count}
    </span>
  );
}
